import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { billingPost } from './api';
import { useAuth } from './authContext';
import { CircularProgress, Typography } from '@mui/material';

const STRIPE_CUSTOMER_WAIT_MS = 8000;

const StartTrial = () => {
  const { customer, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [waitedTooLong, setWaitedTooLong] = useState(false);

  // The customer doc is set up asynchronously right after login (authContext.js);
  // give it a few seconds to show up before giving up.
  useEffect(() => {
    const timer = setTimeout(() => setWaitedTooLong(true), STRIPE_CUSTOMER_WAIT_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!customer || !customer.id) {
      if (waitedTooLong) {
        setError("We couldn't set up billing for your account. Please contact support@shopik.io.");
      }
      return;
    }

    const priceId = searchParams.get('priceId');
    const ref = searchParams.get('ref');

    if (!priceId) {
      setError('Missing plan selection.');
      return;
    }

    // The server links/creates the Stripe customer from shopikCustomerId if needed.
    billingPost('/create-stripe-checkout-session', {
      priceId,
      shopikCustomerId: customer.id,
      customerId: customer.stripeCustomerId,
      withTrial: true,
      ref,
    })
      .then((session) => {
        if (session.url) {
          window.location.href = session.url;
        } else {
          setError('Could not start checkout. Please try again.');
        }
      })
      .catch(() => {
        setError('Could not start checkout. Please try again.');
      });
  }, [customer, loading, searchParams, waitedTooLong]);

  return (
    <div style={{ textAlign: 'center', marginTop: '60px' }}>
      {error ? (
        <Typography variant="h6" color="error">{error}</Typography>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: 20 }}>
            Setting up your free trial...
          </Typography>
        </>
      )}
    </div>
  );
};

export default StartTrial;
